import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import globalData from "./globalDataSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    globalData: globalData,
  }
});
